import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class CollapsibleCard extends Component {

    // Flag to check if the component has been mounted
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = { open: true };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Card className="margin-top-10 k-widget">
                <CardHeader className="k-card-header" onClick={() => { if (this._isMounted) this.setState({ open: !this.state.open }); }}>
                    <div className="row">
                        <h5 className="employeeinformationlabel col-md-8 col-sm-10 text-left">{this.props.title}</h5>
                        <div className="col-md-4 col-sm-2 text-end">
                            {this.props.collapsible !== false ?
                            <FontAwesomeIcon icon={this.state.open ? 'minus' : 'plus'} /> : null}
                        </div>
                    </div>
                </CardHeader>
                <Collapse isOpen={this.state.open}>
                    <CardBody className="k-content">
                    {this.props.children}
                    </CardBody>
                </Collapse>
            </Card>
        );
    }
}
